export const reconciliationReasonChange = {
  amoStaffReview: "AMO staff review",
  annualReportingCompleted: "Annual reporting completed",
  revisionRequested: "Revision requested",
};
